let Config = {
  streamInterval: 18,
  numSensors: 8,
  xLineTicks: 110,
  sensorColours: [
    "#f44336",
    "#E91E63",
    "#673AB7",
    "#3F51B5",
    "#03A9F4",
    "#009688",
    "#4CAF50",
    "#FFEB3B"
  ]
};

export default Config;
